import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { DOCS_CATEGORIES, getArticlesByCategory } from "@/data/docsArticles";

interface DocsSidebarProps {
  currentSlug: string;
}

export function DocsSidebarContent({ currentSlug }: DocsSidebarProps) {
  const { t } = useTranslation(['common']);
  const params = useParams();

  const langPrefix = params.lang ? `/${params.lang}` : '';
  const buildLink = (slug: string) => `${langPrefix}/docs/${slug}`;
  const buildExternal = (path: string) => `${langPrefix}/${path}`;

  return (
    <nav className="space-y-6">
      {DOCS_CATEGORIES.map(cat => {
        const Icon = cat.icon;
        const articles = getArticlesByCategory(cat.key);
        return (
          <div key={cat.key}>
            <div className="flex items-center gap-2 mb-3 px-3">
              <Icon className="w-4 h-4 text-[var(--color-brand-blue-text)]" />
              <span className="text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400">
                {t(cat.titleKey)}
              </span>
            </div>
            <ul className="space-y-1">
              {articles.map(article => {
                const isActive = article.slug === currentSlug;
                const href = article.externalPath ? buildExternal(article.externalPath) : buildLink(article.slug);
                return (
                  <li key={article.slug}>
                    <Link
                      to={href}
                      className={`block px-3 py-2 rounded-lg text-sm transition-colors ${
                        isActive
                          ? "bg-blue-500/10 text-[var(--color-brand-blue-text)] border-l-2 border-blue-500/50 dark:border-blue-500 pl-[10px]"
                          : "text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-white/5"
                      }`}
                    >
                      {t(article.titleKey)}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
        );
      })}
    </nav>
  );
}
